// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsMain_wrapper__Qvh+4","title":"TermsMain_title__J1g5l","line":"TermsMain_line__xeQ2y"};